<template>
  <component :is="linkTag" v-bind="linkAttributes" class="component-link__container" data-test-component-link>
    <slot />
  </component>
</template>

<script>
import { computed, defineComponent, toRefs, useNuxtApp } from '#imports'
import urlUtils from '@b2ag/utils/src/url'
import { getConfig } from '@b2ag/micro-front-tools'

export default defineComponent({
  name: 'CComponentLink',
  props: {
    url: {
      type: String,
      default: '',
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    componentTag: {
      type: String,
      default: undefined,
    },
  },
  setup(props) {
    const { url, isMobile } = toRefs(props)
    const nuxtApp = useNuxtApp()

    const prefix = getConfig('BASE_URL').includes('localhost') ? 'http' : 'https'
    const href =
      typeof window !== 'undefined'
        ? window.location.href
        : prefix + '://' + getConfig('BASE_URL') + nuxtApp.ssrContext.url
    const isExternal = computed(() => urlUtils.methods.isExternalLink(url.value, href))

    const linkAttributes = computed(() => {
      if (isExternal.value) {
        const attributes = {
          href: url.value,
        }
        if (!isMobile.value) {
          attributes.target = '_blank'
          attributes.rel = 'noopener noreferrer'
        }
        return attributes
      }
      return {
        to: urlUtils.methods.urlToRoute(url.value),
      }
    })

    const linkTag = computed(() => {
      if (props.componentTag) {
        return props.componentTag
      }
      return isExternal.value ? 'a' : 'router-link'
    })

    return {
      linkAttributes,
      linkTag,
    }
  },
})
</script>
